module.exports = __webpack_public_path__ + "vue/img/person.2960718f.png";